import * as THREE from 'three';
const UP = new THREE.Vector3();
const NORMAL = new THREE.Vector3();
const RIGHT = new THREE.Vector3();
const BASIS = new THREE.Matrix4();
/** Face the camera around the post axis, keeping the fly's entire hoist attached. */
export function resolveFlagFlyRotation(postOffset, cameraRotation, target) {
    UP.set(...postOffset).negate();
    if (UP.lengthSq() < 1e-12)
        UP.set(0, 1, 0);
    UP.normalize();
    NORMAL.set(0, 0, 1).applyQuaternion(cameraRotation);
    NORMAL.addScaledVector(UP, -NORMAL.dot(UP));
    if (NORMAL.lengthSq() < 1e-12) {
        RIGHT.set(1, 0, 0).applyQuaternion(cameraRotation);
        NORMAL.crossVectors(RIGHT, UP);
    }
    NORMAL.normalize();
    RIGHT.crossVectors(UP, NORMAL).normalize();
    return target.setFromRotationMatrix(BASIS.makeBasis(RIGHT, UP, NORMAL));
}
/** Preserve the attachment while cancelling every inherited rotation and scale. */
export function resolveFlagPostTransform(parentWorld, attachment, target) {
    const e = parentWorld.elements;
    const [x, y, z] = attachment;
    const worldX = e[12] + x;
    const worldY = e[13] + y;
    const worldZ = e[14] + z;
    target.copy(parentWorld).invert();
    const inverse = target.elements;
    inverse[12] = inverse[0] * worldX + inverse[4] * worldY + inverse[8] * worldZ + inverse[12];
    inverse[13] = inverse[1] * worldX + inverse[5] * worldY + inverse[9] * worldZ + inverse[13];
    inverse[14] = inverse[2] * worldX + inverse[6] * worldY + inverse[10] * worldZ + inverse[14];
    return target;
}
